<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- The front figure as User; the back figure trimmed to keep a gap. -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2zM12.5 7a3.5 3.5 0 1 0 -7 0a3.5 3.5 0 1 0 7 0ZM15.667 3.564A3.5 3.5 0 0 1 15.667 10.436A7.5 7.5 0 0 0 15.667 3.564zM20 15.5a4 4 0 0 1 2 3.5v2h-2z"
    />
  </svg>
</template>
